<div class="detail" *ngIf="loaded">
    <div class="side">
        <group-detail-sidebar [users]="allUsers" [model]="requestGroup" (actionEvent)="onActionEvent($event)"></group-detail-sidebar>
    </div>
    <div class="main" [ngClass]="{'isDirect': requestGroup.isDirect}">
        <div class="top-section">
            <div class="title-section">
                <div class="title">{{requestGroup.name}}</div>
                <div class="description">{{requestGroup.description}}</div>
            </div>
            <div class="option">
                <button mat-stroked-button (click)="openEditForm()">Chỉnh sửa</button>
                <button mat-icon-button [matMenuTriggerFor]="groupMenu" aria-label="Example icon-button with a menu">
                    <mat-icon>more_vert</mat-icon>
                </button>
            </div>
        </div>
        <div class="section">
            <div class="section-header">
                <div class="title">Mẫu form đề xuất</div>
                <div class="description">Nhập trường dữ liệu tùy chỉnh</div>
                <div class="option">
                    <button mat-stroked-button color="warn" (click)="openAttributeForm()">+ Thêm</button>
                </div>
            </div>
            <div class="list">
                <attribute-item *ngFor="let attributeItem of requestGroup.orderedAttrs"
                                [group]="requestGroup" [attribute]="attributeItem"
                                (dataChanged)="onActionEvent($event)"
                                (attributeChanged)="onActionEvent($event)"></attribute-item>
            </div>
        </div>
        <div class="section">
            <div class="section-header">
                <div class="title">Người xét duyệt</div>
                <div class="description">Danh sách các thành viên xét duyệt đề xuất</div>
                <div class="option">
                    <button mat-stroked-button color="warn" (click)="openUserSelect('approver')">+ Thêm</button>
                </div>
            </div>
            <div class="list">
                <user-info-item *ngFor="let approver of approvers"
                                showOption="true"
                                [user]="approver"
                                (remove)="onRemoveApprover($event)"></user-info-item>
            </div>
        </div>
        <div class="section">
            <div class="section-header">
                <div class="title">Người theo dõi</div>
                <div class="description">Danh sách các thành viên có thể xem đề xuất trong nhóm và xuất báo cáo</div>
                <div class="option">
                    <button mat-stroked-button color="warn" (click)="openUserSelect('follower')">+ Thêm</button>
                </div>
            </div>
            <div class="list">
                <user-info-item *ngFor="let follower of followers"
                                showOption="true"
                                [user]="follower"
                                (remove)="onRemoveFollower($event)"></user-info-item>
            </div>
        </div>
        <div class="section">
            <div class="section-header">
                <div class="title">Nhóm chuyển tiếp</div>
                <div class="description">Danh sách các nhóm có thể chuyển tiếp đề xuất</div>
                <div class="option">
                    <button mat-stroked-button color="warn" (click)="openGroupSelect()">+ Thêm</button>
                </div>
            </div>
            <div class="list">
                <div class="forward-group-item d-flex" *ngFor="let group of forwardGroups">
                    <div class="m-2 info flex-grow-1">
                        <div class="group-name">{{group.targetName}}</div>
                        <div class="group-title">
                            Cho phép chuyển tiếp khi: <b>{{group.status}}</b>
                        </div>
                    </div>
                    <div class="m-2 options">
                        <div class="m-1 group-option" (click)="onEditForwardGroup(group)">Chỉnh sửa</div>
                        <div class="m-1 group-option" (click)="onDeleteForwardGroup(group)">Xóa</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section">
            <div class="section-header">
                <div class="title">Mẫu in</div>
                <div class="description">Mẫu in tự động (docx)</div>
                <div class="option">
                    <button mat-stroked-button color="warn" (click)="formUploader.click()">+ Thêm</button>
                    <input hidden type="file" #formUploader accept=".doc,.docx" (change)="uploadForm($event)" />
                </div>
            </div>
            <div class="list">
                <div class="file-item d-flex" *ngFor="let file of fileInfos" (click)="onDownloadFile(file)">
                    <div class="download"><mat-icon> vertical_align_bottom</mat-icon></div>
                    <div class="name flex-grow-1">{{file.fileName}}</div>
                </div>
            </div>
        </div>
    </div>
</div>

<mat-menu #groupMenu="matMenu">
    <button mat-menu-item (click)="groupRequests()">
        <mat-icon>trending_flat</mat-icon>
        <span class="title">Xem đề xuất</span>
    </button>
    <button mat-menu-item (click)="createRequest()">
        <mat-icon>adjust</mat-icon>
        <span class="title">Tạo đề xuất mới</span>
    </button>
    <button mat-menu-item (click)="cloneGroup()">
        <mat-icon>toll</mat-icon>
        <span class="title">Nhân bản nhóm đề xuất</span>
    </button>
    <button mat-menu-item (click)="exportRequests()">
      <mat-icon>import_export</mat-icon>
      <span>Xuất đề xuất ra file Excel</span>
    </button>
    <button mat-menu-item (click)="deleteGroup()">
        <mat-icon>delete_outline</mat-icon>
        <span class="title">Xóa nhóm đề xuất</span>
    </button>
</mat-menu>
